export const hasItems = (items) => !!items && items.length > 0;
export const mapWithAssert = (array, callback) => array.map(callback);
